import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';

export function validarSerial() {
  return (c: FormControl) => {
    return algoritmoSerie(c) ? null : { invalidSerial: true };
  };
}

@Directive({
  selector:
    '[directiveValidaNumeroDocumento][ngModel],[directiveValidaNumeroDocumento][formControl]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SerialValidador),
      multi: true
    }
  ]
})
// eslint-disable-next-line
export class SerialValidador {
  // eslint-disable-next-line
  private readonly validator: Function;

  constructor() {
    this.validator = validarSerial();
  }

  public validate(c: FormControl) {
    return this.validator(c);
  }
}

export function algoritmoSerie(c: FormControl) {
  if (c.value) {
    const removerPuntos = c.value.split('.').join('');
    const regexp = new RegExp(
      removerPuntos.charAt(0) !== 'A' ? '^[0-9A-Z]{9}$' : "^['A']{1}[0-9]{9}$",
      'g'
    );
    return regexp.test(removerPuntos);
  }

  return null;
}
